import { useState, useCallback } from 'react';

export type ModalType =
  | 'documentViewer'
  | 'documentEmail'
  | 'documentBulkEmail'
  | 'documentRename'
  | 'documentDelete'
  | 'documentUpload'
  | null;

interface ModalState {
  type: ModalType;
  data?: any;
}

export function useModalManager() {
  const [modalState, setModalState] = useState<ModalState>({ type: null });

  const openModal = useCallback((type: ModalType, data?: any) => {
    // Force close any existing modal first
    setModalState({ type: null });
    
    // Small delay to ensure previous modal is fully closed
    setTimeout(() => {
      setModalState({ type, data });
    }, 50);
  }, []);

  const closeModal = useCallback(() => {
    setModalState({ type: null });
  }, []);

  const isModalOpen = useCallback((type: ModalType) => {
    return modalState.type === type;
  }, [modalState.type]);

  return {
    modalState,
    openModal,
    closeModal,
    isModalOpen,
    currentModal: modalState.type,
    modalData: modalState.data,
  };
}
